import { IAccountUpgradeFromAccountProductCode } from './IAccountUpgradeFromAccountProductCode';

export class KasasaAccountUpgradeFromAccountProductCode implements IAccountUpgradeFromAccountProductCode {
  id?: number;

  externalProductMappingId: number;

  coreAccountType: string;

  coreProductCode: string;

  constructor(externalProductMappingId: number, coreAccountType: string, coreProductCode: string, id?: number) {
    this.externalProductMappingId = externalProductMappingId;
    this.coreAccountType = coreAccountType;
    this.coreProductCode = coreProductCode;
    this.id = id;
  }

  isEquivalentWithoutId(other?: IAccountUpgradeFromAccountProductCode): boolean {
    if (!other) {
      return false;
    }

    return this.coreAccountType === other.coreAccountType && this.coreProductCode === other.coreProductCode
      && this.externalProductMappingId === other.externalProductMappingId;
  }

  static from(other: IAccountUpgradeFromAccountProductCode) {
    return new KasasaAccountUpgradeFromAccountProductCode(other.externalProductMappingId, other.coreAccountType, other.coreProductCode, other.id);
  }

  static fromWithoutId(other: IAccountUpgradeFromAccountProductCode) {
    return new KasasaAccountUpgradeFromAccountProductCode(other.externalProductMappingId, other.coreAccountType, other.coreProductCode);
  }
}

export default KasasaAccountUpgradeFromAccountProductCode;
